export const EXCLUDED_SYSTEM_EMAILS: string[] = [
  "ccareadm@mafrahospitalar.com.br",
];

export interface IUserSuggestionEligibilityInput {
  email?: string | null;
  enabled?: boolean | null;
}

export function isEligibleUserSuggestion(
  user: IUserSuggestionEligibilityInput | null | undefined
): boolean {
  if (!user) return false;
  if (user.enabled !== true) return false;

  const email = (user.email ?? "").trim().toLowerCase();
  if (!email) return false;

  return !EXCLUDED_SYSTEM_EMAILS.some(
    (excludedEmail) => excludedEmail.toLowerCase() === email
  );
}
